// extracted by mini-css-extract-plugin
export default {"base":"sidebar-detail_base__H66nn","label":"sidebar-detail_label__-ba1D"};